import React from 'react'
import ReactDOM from 'react-dom'
import services from 'services'
import ChromePopupApp from './PopupApp'

export function launchChromeExtension() {
  const root = document.getElementById('__itx-popup-app')
  // we are in the chrome extension popup app
  if (root) {
    // @ts-ignore
    document.body.style = 'width: 320px; height: 340px;'
    ReactDOM.render(<ChromePopupApp />, root)
  } else {
    // we are  in the chrome content app
    services.getChromeContentService()
  }
}
